
        import 'ElementEditor.f40f099.css-module'
        export default {"ElementEditor":"ElementEditor_ElementEditor_f40f099","addEntry":"addEntry_ElementEditor_f40f099","deleteEntry":"deleteEntry_ElementEditor_f40f099","deletedEntry":"deletedEntry_ElementEditor_f40f099","tagModal":"tagModal_ElementEditor_f40f099"}
    